module.exports = __webpack_public_path__ + "img/tertiary_1x1.32688d28.svg";